import {AdvancedTable, useAdvancedTable, useFilterContext} from '@eitje/web_components'
import {TABLE_INFO} from './constants'
import {columns} from './columns'

export const BillingInfosAdvancedTable = () => {
	'use no memo' // @tanstack/react-table is not compatible with the react compiler
	const {items} = useFilterContext()

	const rowToLink = row => `${row.original.id}`

	const tableData = useAdvancedTable({data: items, columns, TABLE_INFO})

	return <AdvancedTable data={tableData} rowTo={rowToLink} />
}
